import React from 'react';

import { Omit } from 'utility-types';

import Dropdown from './Dropdown';

type Props = Omit<React.ComponentProps<typeof Dropdown>, 'theme' | 'styles'> & {
    isLarge?: boolean;
    isSecondary?: boolean;
};

const ButtonDropdown = (props: Props) => (
    <Dropdown size="md" color="primary" valueMode="single" {...props} />
);

export default ButtonDropdown;
